export default __webpack_public_path__ + "static/media/import.07ef5bfb.svg";